<template>
  <div>
    <template v-if="field.type === FieldType.Text">
      <UInput
        v-model="model"
        :disabled="disabled"
        size="lg"
      />
    </template>

    <template v-else-if="field.type === FieldType.TextArea">
      <UTextarea
        v-model="model"
        :disabled="disabled"
        size="lg"
      />
    </template>

    <template v-else-if="field.type === FieldType.List">
      <USelect
        v-model="model"
        :options="options"
        :disabled="disabled"
        size="lg"
      />
    </template>

    <template v-else-if="field.type === FieldType.Checkbox">
      <UToggle
        v-model="model"
        :disabled="disabled"
        size="lg"
      />
    </template>

    <template v-else-if="field.type === FieldType.Number">
      asd
      <UInput
        v-model="model"
        type="number"
        :disabled="disabled"
        size="lg"
      />
    </template>

    <template v-else-if="field.type === FieldType.Date">
      <FieldsDate
        v-model="model"
        :disabled="disabled"
        size="lg"
      />
    </template>

    <template v-else>
      <div>Unknown field type: {{ field.type }}</div>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { Field } from '@@/types/api';

interface Props {
  field: Field
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false
})

const model = defineModel()

const options = computed(() => {
  if (props.field.custom && props.field.customField) {
    return props.field.customField.multipleValues
  }

  return props.field.options || []
})

const FieldType = {
  Text: 'text',
  TextArea: 'textarea',
  List: 'list',
  Checkbox: 'checkbox',
  Date: 'date',
  Number: 'number'
} as const
</script>